const styles = {
  root: {
    width: '80%',
    background: 'rgba( 0,0,0,0)',
  },
};

export default styles